// src/modules/apiClient.js
const buildUrl = (path) => `${path}`;

function safeParseJson(response) {
  return response.json().catch(() => null);
}

export const postJson = async (path, payload) => {
  const response = await fetch(buildUrl(path), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await safeParseJson(response);
  return { response, data };
};

export const postFormData = async (path, formData) => {
  const response = await fetch(buildUrl(path), {
    method: 'POST',
    body: formData,
  });

  const data = await safeParseJson(response);
  return { response, data };
};

export const getJson = async (path) => {
  const response = await fetch(buildUrl(path), { method: 'GET' });
  const data = await safeParseJson(response);
  return { response, data };
};